import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function Reports() {
  const [overview, setOverview] = useState(null);
  const [promoStats, setPromoStats] = useState([]);

  useEffect(() => {
    api.get("/admin/stats/overview").then(({ data }) => setOverview(data));
    api.get("/admin/stats/promotions").then(({ data }) => setPromoStats(data));
  }, []);

  if (!overview) return <div className="p-10 font-mono text-sm text-zinc-500">Loading…</div>;

  const sourcesData = overview.sources;
  const demoData = overview.demo_trends;

  return (
    <div className="p-8 md:p-10" data-testid="admin-reports">
      <p className="overline mb-2">Reports</p>
      <h1 className="text-3xl font-bold tracking-tight mb-8" style={{ fontFamily: "'Outfit', sans-serif" }}>Business reports</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <ChartCard title="Leads by source">
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={sourcesData}>
              <CartesianGrid vertical={false} stroke="#E4E4E7" />
              <XAxis dataKey="source" tick={{ fontSize: 11, fill: "#71717A" }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#71717A" }} />
              <Tooltip cursor={{ fill: "#F4F4F5" }} />
              <Bar dataKey="count" fill="#E11D48" />
            </BarChart>
          </ResponsiveContainer>
        </ChartCard>

        <ChartCard title="Demo interest">
          {demoData.length === 0 ? (
            <p className="text-sm text-zinc-500 font-mono py-12 text-center">No demo interest yet.</p>
          ) : (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={demoData} layout="vertical">
                <CartesianGrid horizontal={false} stroke="#E4E4E7" />
                <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11, fill: "#71717A" }} />
                <YAxis dataKey="title" type="category" tick={{ fontSize: 11, fill: "#71717A" }} width={120} />
                <Tooltip cursor={{ fill: "#F4F4F5" }} />
                <Bar dataKey="count" fill="#0A0A0A" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </ChartCard>
      </div>

      <div className="bg-white border border-zinc-200" data-testid="promo-stats">
        <div className="px-6 py-4 border-b border-zinc-200"><h2 className="text-sm font-semibold uppercase tracking-widest font-mono text-zinc-600">Promotion performance</h2></div>
        <table className="w-full text-sm">
          <thead className="bg-zinc-50">
            <tr className="text-left">
              {["Title", "Status", "Views", "Conversions", "Conv. rate"].map((h) => (
                <th key={h} className="px-6 py-3 font-mono text-[10px] uppercase tracking-widest text-zinc-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {promoStats.length === 0 ? (
              <tr><td colSpan={5} className="p-8 text-center text-zinc-500 font-mono">No promotions to report on.</td></tr>
            ) : promoStats.map((p) => (
              <tr key={p.id} className="border-t border-zinc-200">
                <td className="px-6 py-3 font-medium">{p.title}</td>
                <td className="px-6 py-3"><span className="status-pill">{p.status}</span></td>
                <td className="px-6 py-3 font-mono">{p.views}</td>
                <td className="px-6 py-3 font-mono">{p.conversions}</td>
                <td className="px-6 py-3 font-mono">{p.conversion_rate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ChartCard({ title, children }) {
  return (
    <div className="bg-white border border-zinc-200 p-6">
      <h2 className="text-sm font-semibold uppercase tracking-widest font-mono text-zinc-600 mb-4">{title}</h2>
      {children}
    </div>
  );
}
